<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'materielQuoteManage')">
            <!-- 物料管理 -->
            <div slot="header">
                <a-form :form="filterForm" layout="inline" class="store-one-form">
                    <a-form-item label="物料编码">
                        <a-input style="width:100%;" placeholder="请输入" v-decorator="['goodsNo']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="物料条形码">
                        <a-input placeholder="请输入" v-decorator="['goodsBarCode']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="物料名称">
                        <a-input placeholder="请输入" v-decorator="['goodsName']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="物料分组">
                        <a-input placeholder="请输入" v-decorator="['goodsGroup']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="物料属性">
                        <a-input placeholder="请输入" v-decorator="['goodsType']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button type="primary" @click="kingDiskSearch" :loading="kingDiskSearchLoading">筛选</a-button>
                        <a-button @click="kingDiskHandleReset" :loading="kingDiskSearchLoading">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div>
                <div class="flex flex-space-between mb8">
                    <div>
                        <span class="text-primary">每天00：00系统自动刷新数据，与金蝶系统数据进行对比同步</span>
                    </div>
                    <div>
                        <a-button type="primary" v-if="getBtnByAuth('batchInputPriceButton')" @click="goMaterielBatchRemind(false)" >批量报价</a-button>
                        <a-button v-else :disabled="true">批量报价</a-button>
                        <a-button type="primary" @click="kingDiskGoodsRefresh" :loading="kingDiskGoodsRefreshLoading">数据刷新</a-button>
                    </div>
                </div>
                <div class="wrap-container-in">
                    <a-table
                    :scroll="{y: 560}"
                    bordered
                    :dataSource="kingDeskData"
                    :columns="columns"
                    :pagination="pagination"
                    :rowKey="record => record.id"
                    :loading="kingDiskSearchLoading"
                    @change="kingDiskChangePage"
                    class="wrap-table"
                    >
                        <template slot="empty" slot-scope="key">
                            {{key || "-"}}
                        </template>
                        <template slot="setBasePrice" slot-scope="key, row">
                            <template v-if="Boolean(shopId == -1) && row.inEdit">
                                <a-input-number @change="baseChange($event, row)" placeholder="请输入" v-model="row.newBasePrice" />
                                <div v-if="row.showBaseError" class="text-fail">所填值不能小于0，且只保留两位小数</div>
                            </template>
                            <template v-else>
                                {{key}}
                            </template>
                        </template>
                        <template slot="setPrice" slot-scope="key, row">
                            <template v-if="row.inEdit">
                                <a-input-number @change="change($event, row)" placeholder="请输入" v-model="row.newPrice" />
                                <div v-if="row.showError" class="text-fail">所填值不能小于0，且只保留两位小数</div>
                            </template>
                            <template v-else>
                                {{key}}
                            </template>
                        </template>
                        <template slot="actions" slot-scope="key,row">
                            <template v-if="!row.inEdit">
                                <a v-if="getBtnByAuth('editPriceButton')" class="text-primary" @click="editPrice(row)">编辑</a>
                                <span v-else class="text-disabled">编辑</span>
                                <a-divider type="vertical"></a-divider>
                            </template>
                            <template v-if="row.inEdit">
                                <a-popconfirm placement="top" @confirm="kingDiskRemindUpdate(row)">
                                    <template slot="title">
                                        确认设置？
                                    </template>
                                    <a class="text-primary">确定</a>
                                </a-popconfirm>
                                <a-divider type="vertical"></a-divider>
                                <a class="text-primary" @click="closeEditPrice(row)">取消</a>
                                <a-divider type="vertical"></a-divider>
                            </template>
                            <a v-if="getBtnByAuth('materielQuoteDetailButton')" class="text-primary" @click="goDetail(row.goodsNo, 1)">物料详情</a>
                            <span v-else class="text-disabled">物料详情</span>
                        </template>
                    </a-table>
                </div>
            </div>
            <a-modal
            centered
            :closable="false"
            :maskClosable="false"
            title="提示"
            :visible="visibleNoBasePriceTips"
            >
                <div>
                    <div class="font-big" v-if="Number(shopId) === -1">当前共有<span class="ml8 mr8 text-fail">{{remindData.count}}</span>个物料未进行默认售卖价报价</div>
                    <div class="font-big" v-else>当前共有<span class="ml8 mr8 text-fail">{{remindData.count}}</span>个物料为最新调拨，请设置售卖价</div>
                </div>
                <template slot="footer">
                    <a-button @click="visibleNoBasePriceTips = false">稍后处理</a-button>
                    <a-button type="primary" @click="goMaterielBatchRemind(true)">马上处理</a-button>
                </template>
            </a-modal>
            <a-modal
            centered
            :visible="visibleSyncing"
            :closable="false"
            :maskClosable="false"
            :footer="null"
            :width="300"
            >
                <div class="text-center text-primary">
                    <a-icon type="sync" class="animated rotate360 infinite slow" style="font-size: 36px;" />
                    <div class="mt24">数据刷新中，请稍等...</div>
                </div>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    const columns = [
        {
            title: '物料编码',
            dataIndex: 'goodsNo',
        },
        {
            title: '物料条形码',
            dataIndex: 'goodsBarCode',
            scopedSlots: { customRender: 'empty' }

        },
        {
            title: '物料名称',
            dataIndex: 'goodsName'
        },
        {
            title: '规格型号',
            dataIndex: 'goodsSpecification'
        },
        {
            title: '数据状态',
            dataIndex: 'documentStatusStr'
        },
        {
            title: '物料分组',
            dataIndex: 'goodsGroup'
        },
        {
            title: '物料属性',
            dataIndex: 'goodsType'
        },
        {
            title: '基本单位',
            dataIndex: 'goodsUnit'
        },
        {
            title: '默认售卖价',
            dataIndex: 'basePrice',
            scopedSlots: { customRender: 'setBasePrice' }
        },
        {
            title: '实际售卖价',
            dataIndex: 'price',
            scopedSlots: { customRender: 'setPrice' }
        },
        {
            title: '操作',
            scopedSlots: { customRender: 'actions' }
        }
    ];
    export default {
        name: 'materielQuoteManage',
        components: {},
        props: {},
        data() {
            return {
                columns,
                kingDeskData: [],
                kingDiskOrganizationList: [],//金蝶机构数据
                visibleSwitchComfirm: false,
                switchOrganizationLoading: false,
                kingDiskSearchLoading: false,
                visibleNoBasePriceTips: false,
                kingDiskGoodsRefreshLoading: false,
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                remindData: {},
                visibleSyncing: false
            };
        },
        watch: {
            '$route'(val) {
                val.name == 'materielQuoteManage' && this.kingDiskMaterielList();
            },
            'shopId'() {
                this.pagination.current = 1;
                this.kingDiskMaterielList();
                if (this.shopId == -1) {
                    this.getKingDiskGoodsRemind();
                } else {
                    this.getKingDiskGoodsShopRemind();
                }
            }
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            /**
             * @baseChange 默认售卖价输入回调
             */
            baseChange(val, record) {
                if (val === '') {
                    record.newBasePrice = undefined;
                    record.showBaseError = false;
                    return
                }
                if (val === null || typeof val === 'undefined') {
                    return false;
                }
                const regExp = /^([0-9]{1,}\d*[.]*\d{0,2})$|^([0]{1}[.]{1}\d{1,2})$/;
                record.showBaseError = !regExp.test(val);
            },
            /**
             * @change 实际售卖价输入回调
             */
            change(val, record) {
                if (val === '') {
                    record.newPrice = undefined;
                    record.showError = false;
                    return
                }
                if (val === null || typeof val === 'undefined') {
                    return false;
                }
                const regExp = /^([0-9]{1,}\d*[.]*\d{0,2})$|^([0]{1}[.]{1}\d{1,2})$/;
                record.showError = !regExp.test(val);
            },
            kingDiskChangePage(page) {
                this.pagination = page;
                this.kingDiskMaterielList();
            },
            // 重置筛选
            kingDiskHandleReset() {
                this.filterForm.resetFields();
                this.kingDiskSearch();
            },
            kingDiskSearch() {
                this.pagination.current = 1;
                this.kingDiskMaterielList();
            },
            /**
             * @goMaterielBatchRemind 跳转批量报价
             */
            goMaterielBatchRemind(isModal) {
                if (isModal) {
                    this.visibleNoBasePriceTips = false;
                    setTimeout(() => {
                        this.$router.push({name: 'materielRemind'});
                    }, 300);
                } else {
                    this.$router.push({name: 'materielRemind'});
                }
            },
            /**
             * @goDetail 跳转详情
             */
            goDetail(id, sysType) {
                this.$router.push({name: 'materielQuoteDetail', params: {id, sysType}});
            },
            /**
             * @kingDiskMaterielList 获取物料详情
             */
            kingDiskMaterielList() {
                if (this.kingDiskSearchLoading || !this.shopId) {
                    return false;
                }
                this.filterForm.validateFields((errors, values) => {
                    if (errors) return;
                    this.kingDiskSearchLoading = true;
                    this.$api.newStorage.kingDiskMaterielList({
                        body: {
                            ...values,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            shopId: this.shopId
                        }
                    }).then(res => {
                        this.kingDiskSearchLoading = false;
                        if (Boolean(res) && Boolean(res.data)) {
                            res.data.forEach(item => {
                                item.inEdit = false;
                                item.newBasePrice = undefined;
                                item.newPrice = undefined;
                                item.showBaseError = false;
                                item.showError = false;
                            });
                            this.kingDeskData = res.data;
                        }
                        this.pagination.total = res.total;
                    }).catch(err => {
                        this.kingDiskSearchLoading = false;
                    });
                })
            },
            /**
             * @getKingDiskGoodsRemind 获取未进行默认售卖价报价提示（总店）
             */
            getKingDiskGoodsRemind() {
                if (!this.shopId || this.$route.name !== 'materielQuoteManage') {
                    return false;
                }
                this.$api.newStorage.kingDiskGoodsRemind({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (res.count > 0) {
                        this.remindData = res;
                        this.visibleNoBasePriceTips = true;
                    }
                });
            },
            /**
             * @getKingDiskGoodsShopRemind 获取未进行默认售卖价报价提示（门店）
             */
            getKingDiskGoodsShopRemind() {
                if (!this.shopId || this.$route.name !== 'materielQuoteManage') {
                    return false;
                }
                this.$api.newStorage.kingDiskGoodsShopRemind({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (res.count > 0) {
                        this.remindData = res;
                        this.visibleNoBasePriceTips = true;
                    }
                });
            },
            /**
             * @kingDiskRemindUpdate 批量修改物料报价
             */
            kingDiskRemindUpdate(row) {
                const regExp = /^([0-9]{1,}\d*[.]*\d{0,2})$|^([0]{1}[.]{1}\d{1,2})$/;
                let allPlatformCondition = ((Number(this.shopId) === -1 && !Boolean(row.basePrice)) && (typeof row.newBasePrice !== undefined && !regExp.test(row.newBasePrice)));
                let shopPlatformCondition = (typeof row.newPrice !== undefined && !regExp.test(row.newPrice));
                if (!Boolean(row.basePrice)) {
                    if (allPlatformCondition && shopPlatformCondition) {
                        this.$message.error('请输入正确的价格');
                        return false;
                    }
                } else {
                    if (shopPlatformCondition) {
                        this.$message.error('请输入正确的价格');
                        return false;
                    }
                }
                this.$api.newStorage.kingDiskRemindUpdate({
                    body: {
                        infoList: [
                            {
                                goodsNo: row.goodsNo,
                                price: row.newBasePrice,
                                realPrice: row.newPrice
                            }
                        ],
                        shopId: this.shopId,
                        userId: this.userInfo.id,
                        account: this.userInfo.account,
                        username: this.userInfo.name
                    }
                }).then(res => {
                    this.$message.success('操作成功！');
                    this.kingDiskMaterielList();
                }).catch(err => {
                });
            },
            /**
             * @kingDiskGoodsRefresh 金蝶物料数据刷新
             */
            kingDiskGoodsRefresh() {
                this.visibleSyncing = true;
                this.kingDiskGoodsRefreshLoading = true;
                this.$api.newStorage.kingDiskGoodsRefreshGoodsInfo({
                    body: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.visibleSyncing = false;
                    this.$message.success('数据刷新成功！', 5);
                    this.kingDiskGoodsRefreshLoading = false;
                    this.kingDiskMaterielList();
                    if (this.shopId == -1) {
                        this.getKingDiskGoodsRemind();
                    } else {
                        this.getKingDiskGoodsShopRemind();
                    }
                }).catch(err => {
                    this.visibleSyncing = false;
                    this.kingDiskGoodsRefreshLoading = false;
                });
            },
            /**
             * @editPrice 编辑价格
             */
            editPrice(row) {
                row.inEdit = true;
                row.newBasePrice = ((row.basePrice || row.basePrice === 0) && this.shopId == -1) ? row.basePrice : undefined;
                row.newPrice = (row.price || row.price === 0) ? row.price : undefined;
            },
            /**
             * @editPrice 编辑价格取消
             */
            closeEditPrice(row) {
                row.inEdit = false;
                row.newBasePrice = undefined;
                row.newPrice = undefined;
                row.showBaseError = false;
                row.showError = false;
            }
        },
        beforeCreate() {
            this.filterForm = this.$form.createForm(this);
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            this.kingDiskMaterielList();
            if (this.shopId == -1) {
                this.getKingDiskGoodsRemind();
            } else {
                this.getKingDiskGoodsShopRemind();
            }
        },
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
</style>
